import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset, signInAdmin, verifyAdminAccess } from '../services/adminService';

function AdminLoginPage() {
  const navigate = useNavigate();
  const [values, setValues] = useState({ email: '', password: '' });
  const [state, setState] = useState({ loading: false, message: '', error: '' });

  useEffect(() => {
    verifyAdminAccess().then((authorized) => {
      if (authorized) {
        navigate('/admin', { replace: true });
      }
    });
  }, [navigate]);

  const update = (event) => {
    setValues((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const submit = async (event) => {
    event.preventDefault();
    setState({ loading: true, message: '', error: '' });
    try {
      await signInAdmin(values.email.trim(), values.password);
      navigate('/admin', { replace: true });
    } catch (error) {
      setState({ loading: false, message: '', error: error.message });
    }
  };

  const resetPassword = async () => {
    if (!values.email.trim()) {
      setState({ loading: false, message: '', error: 'Enter your admin email address first.' });
      return;
    }
    try {
      await requestPasswordReset(values.email.trim());
      setState({ loading: false, error: '', message: 'Password reset link sent to your email.' });
    } catch (error) {
      setState({ loading: false, message: '', error: error.message });
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-wrapper">
        <form className="admin-login-card" onSubmit={submit}>
          <div className="admin-login-brand">
            <span className="admin-login-brand-text">ZEVI</span>
            <small>ADMINISTRATION</small>
          </div>

          <div className="admin-login-heading">
            <span className="eyebrow">Sign In</span>
            <h2>Admin Portal</h2>
            <p>Access your store dashboard, orders, and products.</p>
          </div>

          <label className="admin-field-label">
            Email address
            <input
              name="email"
              type="email"
              autoComplete="username"
              required
              placeholder="admin@zevilanka.com"
              value={values.email}
              onChange={update}
            />
          </label>

          <label className="admin-field-label">
            Password
            <input
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="••••••••"
              value={values.password}
              onChange={update}
            />
          </label>

          {state.error && (
            <p className="admin-alert error" role="alert">{state.error}</p>
          )}
          {state.message && (
            <p className="admin-alert success" role="status">{state.message}</p>
          )}

          <button className="admin-btn-primary full-width" type="submit" disabled={state.loading}>
            {state.loading ? 'Signing in…' : 'Sign in to Dashboard'}
          </button>

          <button className="admin-link-button" type="button" onClick={resetPassword}>
            Forgot password?
          </button>
        </form>
      </div>
    </main>
  );
}

export default AdminLoginPage;